import moment = require("moment");
import { utilities } from "uicomponents";
declare var persianDate:(any)=>void;

export class Converters{
    notConverter(t){
        return !t;
    }
    
    public b64ToSrcConverter(t){
        return `data:image/png;base64,${t}`;
    }
    b64ToSrcConverterReverse(t){
        if(t && utilities.isString(t) && t.indexOf(',')>-1)
            return t.split(',')[1];
        return null;
    }

    rgbaToArgbString(v){
        let a = ("0"+((v & 0xFF000000) >>> 24).toString(16)).slice(-2);
        let r = ("0"+((v & 0x00FF0000) >>> 16).toString(16)).slice(-2);
        let g = ("0"+((v & 0x0000FF00) >>> 8).toString(16)).slice(-2);
        let b = ("0"+((v & 0x000000FF) >>> 0).toString(16)).slice(-2);
        let result = `#${r}${g}${b}${a}`;
        return result;
    }

    localDateConverter(d:moment.Moment):string{
        if(d==null) return '';
        if(d instanceof String || typeof d=='string') d=moment(d);
        d = d.clone().local();
        let date = new persianDate(d.toDate());

        let result = date.format(`YYYY/MM/DD HH:mm:ss`)
        
        return result;
    }
    DatePartLocalDateConverter(d:moment.Moment):string{
        if(d==null) return '';
        if(d instanceof String || typeof d=='string') d=moment(d);
        d = d.clone().local();
        let date = new persianDate(d.toDate());

        let result = date.format(`YYYY/MM/DD`)
        
        return result;
    }
    TimePartLocalDateConverter(d:moment.Moment):string{
        if(d==null) return '';
        if(d instanceof String || typeof d=='string') d=moment(d);
        d = d.clone().local();
        let result = d.format(`HH:mm:ss`)
        
        return result;
    }
    NumberWithCommas(x) {
        return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    RemoveCommas(x:string){
        return x?.replace(/\,/g,"");
    }

    numberSplit(x:string){
        return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    
    numberSplitReverse(x:string){
        return x?.replace(/\,/g,"");
    }

    ConvertPricingIndexName(value:number):string{
        switch(value){
            case 0: return '';
            case 1: return 'جاری';
            case 2: return '۱ ماه';
            case 3: return '۲ ماه';
            case 4: return '۳ ماه';
            case 5: return '۴ ماه';
            case 6: return '۵ ماه';
            case 7: return '۶ ماه';
            case 8: return '۷ ماه';
            case 9: return '۸ ماه';
            case 10: return '۹ ماه';
            case 12: return 'بیش از ۱۰ ماه';
            default: return '';
        }
    } 
    ConvertPricingCalculationTypeName(value:number):string{
        switch(value){
            case 1:   return 'رقابتی';
            case 2:   return 'احتیاط - درصد انتخابی';
            case 20:  return 'تخفیف 145 درصد';
            case 21:  return 'تخفیف 141 درصد';
            case 22:  return 'تخفیف 140 درصد';
            case 23:  return 'تخفیف 139 درصد';
            case 24:  return 'تخفیف 138 درصد';
            case 25:  return 'تخفیف 137 درصد';
            case 26:  return 'تخفیف 136 درصد';
            case 309: return 'دهک ۱ - M 120 درصد';
            case 308: return 'دهک ۲ - M 120 درصد';
            case 307: return 'دهک ۳ - M 120 درصد';
            case 306: return 'دهک ۴ - M 117 درصد';
            case 305: return 'دهک ۵ - M 117 درصد';
            case 304: return 'دهک ۶ - M 113 درصد';
            case 303: return 'دهک ۷ - M 113 درصد';
            case 302: return 'دهک ۸ - M 110 درصد';
            case 301: return 'دهک ۹ - M 110 درصد';
            case 300: return 'دهک ۱۰ - M 110 درصد';
            case 409: return 'دهک ۱ - HM 126 درصد';
            case 408: return 'دهک ۲ - HM 124 درصد';
            case 407: return 'دهک ۳ - HM 122 درصد';
            case 406: return 'دهک ۴ - HM 120 درصد';
            case 405: return 'دهک ۵ - HM 118 درصد';
            case 404: return 'دهک ۶ - HM 116 درصد';
            case 403: return 'دهک ۷ - HM 115 درصد';
            case 402: return 'دهک ۸ - HM 115 درصد';
            case 401: return 'دهک ۹ - HM 115 درصد';
            case 400: return 'دهک ۱۰ - HM 115 درصد';
            case 509: return 'دهک ۱ - HMS 135 درصد';
            case 508: return 'دهک ۲ - HMS 133 درصد';
            case 507: return 'دهک ۳ - HMS 131 درصد';
            case 506: return 'دهک ۴ - HMS 129 درصد';
            case 505: return 'دهک ۵ - HMS 127 درصد';
            case 504: return 'دهک ۶ - HMS 125 درصد';
            case 503: return 'دهک ۷ - HMS 123 درصد';
            case 502: return 'دهک ۸ - HMS 121 درصد';
            case 501: return 'دهک ۹ - HMS 119 درصد';
            case 500: return 'دهک ۱۰ - HMS 117 درصد';
            case 6: return 'فروش در 4 روز';
            default: return '';
        }
    } 
    ConvertCallFactorType(value: any) {
        switch(value){
            case 0:
                return 'دارای موجودی بدون فاکتور';
            case 1:
                return 'بدون موجودی';
            case 2:
                return 'فاکتور';
            case 3:
                return 'بدون هانت';
            default: return '';
        }
    }
    ConvertPriceToInquiryPriceRelation(value:any){
        switch(value){
            case 0:
                return 'کاهش';
            case 1:
                return 'افزایش';
            case 2:
                return 'عادی';
            default: return 'عادی';
        }
    }

    callDirectionTranslate(value:any){
        switch(value){
            case 1:
                return 'داخلی';
            case 2:
                return 'ورودی';
            case 3:
                return 'خروجی';
            default: return '';
        }
    }
    persianDateConverterNoTime(d:moment.Moment):string{
        if(d==null) return '';
        if(d instanceof String || typeof d=='string') d=moment(d);
        d = d.clone().local();
        let date = new persianDate(d.toDate());
        let result = date.format(`YYYY/MM/DD`)
        
        return result;
    }
}